import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { UserOnboardingService } from '../../../public/user-onboarding/user-onboarding.service';
import { User } from '../../types/user.model';

@Component({
  selector: 'mmb-web-app-add-need-support-with-items-modal',
  templateUrl: './add-need-support-with-items-modal.component.html',
  styleUrls: ['./add-need-support-with-items-modal.component.scss']
})
export class AddNeedSupportWithItemsModalComponent implements OnInit {
  @Output() addSuccess: EventEmitter<string> = new EventEmitter<string>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  @Input() user: User;
  @Input() userRequests;
  @Input() userOffers;

  form: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder, private userOnboardingService: UserOnboardingService) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      userNeedsSupportOn: [this.userRequests && this.userRequests.length > 0 ? this.userRequests : null, [Validators.required, Validators.maxLength(60)]],
      userNeedsHelpOn: [this.userOffers && this.userOffers.length > 0 ? this.userOffers : null, [Validators.required, Validators.maxLength(60)]],
    });
  }

  onClose() {
    this.closed.emit();
  }
}
